export default function featureToggles(unleash: any): any {
  return {
    calendarDayView: unleash.isEnabled('calendar_day_view'),
    calendarWeekView: unleash.isEnabled('calendar_week_view')
  };
}
